module.exports = __webpack_public_path__ + "static/media/1_5.0e69e54e.png";